import React from 'react'

// material ui
import Box from '@mui/material/Box'

// containers
import Session from './Session'
import AddGuestPass from './AddGuestPass'

// components
import PersonCard from 'components/shared/PersonCard'
import CamperStatusAvatar from 'components/shared/CamperStatusAvatar'
import { useBrand } from 'components/shared/SettingsProvider'

const CartCamper = props => {
  const { id: brandId } = useBrand()
  const {
    camper, // via withQuery
    sessions, // via withQuery
    inputErrors, // via withFormResults
    selectedSession, // via withState
    selectSession, // via withState
    onToggleDate // via props
  } = props

  const { plans } = camper
  const status = plans.length ? 'Registered' : 'Not Registered'

  // detect the CamperSession metadata for the given camper and session
  const findCamperSession = (camper, session) =>
    camper.camperSessions.find(cs => cs.session.id === session.id)

  // Only render  sessions we can resolve to a camperSession so a transient
  // mismatch can't crash the cart.
  const displayableSessions = sessions
    .map(session => ({
      session,
      camperSession: findCamperSession(camper, session)
    }))
    .filter(({ camperSession }) => camperSession)

  const defaultOpen = displayableSessions.length === 1

  return (
    <Box key={camper.id} my={4}>
      <PersonCard
        header={<CamperStatusAvatar camper={camper} status={status} />}
      >
        {displayableSessions.map(({ session, camperSession }) => (
          <Session
            key={session.id}
            defaultOpen={defaultOpen}
            camper={camper}
            session={session}
            inputErrors={inputErrors}
            camperSession={camperSession}
            selectedSession={selectedSession}
            selectSession={selectSession}
            account={props.account}
            onToggleDate={onToggleDate}
          />
        ))}
        {brandId !== 'sciencefactory' && <AddGuestPass camper={camper} />}
      </PersonCard>
    </Box>
  )
}

export default CartCamper
